import { environment } from "../../../environments/environment";
import { BaseModel } from "./base/base.model";

export class AppConfiguracionEntorno extends BaseModel {

  IdCliente?: string;
  environment1?: string;
  pushAcceptText: string;
  pushDenyText: string;
  mailAcceptText: string;
  mailDenyText: string;
  image: string;
  stamp: string;
  imageData: {
    name: string;
    mimeType: string;
    base64: string;
    base64FullData: string
  };
  stampData: {
    name: string;
    mimeType: string;
    base64: string;
    base64FullData: string
  };
  customRedirection: {
    redirectionId?: string;
    name?: string;
    image?: string;
    androidUrl?: string;
    iosUrl?: string;
    createdAt?: Date;
    modifiedO?: Date;
    showButtonRedirection: boolean;
    imageDefault?: string;
  };
  myreportinLicence?: string;
  livesAppLicence?: string;
  hostelLicence?: string;
  conectia?: boolean;
}
